// removed by extract-text-webpack-plugin
module.exports = {"full":"_3sSyJcH7vansW2p2iY8NQw"};


/*****************
 ** WEBPACK FOOTER
 ** ../app/Components/Banner/styles.scss
 ** module id = 442
 ** module chunks = 0
 **/